import axiosIns from "@/libs/axios";

const fetchTokenByBrand = () => {
  return JSON.parse(localStorage.getItem(window.brandLocalStorage))?.find((o) => {
    return (
      o.brandRef ==
        new URLSearchParams(window.location.search).get("brandRef") ||
      o.brandRef == sessionStorage.getItem(window.brandSessionStorage)
    );
  })?.accessToken;
};

const buildPayload = (model) => {
  return {
    method: model.method.toLowerCase(),
    url: model.api,
    headers: {
      Authorization: "Bearer " + fetchTokenByBrand(),
      [model.xRequestId && "X-Request-Id"]: model.xRequestId,
    },
    [model.method == "GET" ? "params" : "data"]: model.payload,
    [model.responseType && "responseType"]: model.responseType,
  };
};

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    apiRequest({}, model) {
      return new Promise((resolve, reject) => {
        axiosIns(buildPayload(model))
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            const error = err.response || err;

            return reject(error);
          });
      });
    },
    apiFormRequest({}, model) {
      return new Promise((resolve, reject) => {
        axiosIns(
          buildPayload({
            ...model,
            ...{
              payload: window.GlobalRequest.CalculateFormDataObject(
                model.payload
              ),
            },
          })
        )
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            const error = err.response || err;

            return reject(error);
          });
      });
    },
  },
};
